<template>
  <router-view />
</template>

<script>
  export default {
    mounted(){
      const debounce = (fn, delay) => {
          let timer = null;

          return function () {
              let context = this;

              let args = arguments;

              clearTimeout(timer);

              timer = setTimeout(function () {
                  fn.apply(context, args);
              }, delay);
          };
      };

      const _ResizeObserver = window.ResizeObserver;

      window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
          constructor(callback) {
              callback = debounce(callback, 16);
              super(callback);
          }
      };
    }
  }
</script>

<style>
  /* 引用element中Icon样式 */
  @import url("//unpkg.com/element-ui@2.15.6/lib/theme-chalk/index.css");
</style>